(function (window, document) {
  'use strict';

  const init_slider = (widget) => {
    const slider = widget.querySelector('.vodl-vn-grund-und-boden__images');
    const sliderAttr = {
      speed: 250,
      minSlides: 1,
      infiniteLoop: true,
      pager: true,
      prevSelector: '.vodl-vn-grund-und-boden__slider-prev',
      nextSelector: '.vodl-vn-grund-und-boden__slider-next',
      prevText: '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="27" viewBox="0 0 12 27" fill="none"><path d="M0.5 13.5L11.75 0.509619L11.75 26.4904L0.5 13.5Z" fill="#E30513"/></svg>',
      nextText: '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="26" viewBox="0 0 12 26" fill="none"><path d="M12 13L0.75 25.9904L0.75 0.00961876L12 13Z" fill="#E30513"/></svg>',
    };

    $(slider).bxSlider(sliderAttr);
    slider.closest('.vodl-vn-grund-und-boden').classList.remove('pre-init');

    slider.addEventListener('touchmove', (e) => {
      e.preventDefault();
    });
  };

  const init = () => {
    const vn_widgets = document.querySelectorAll('.vodl-vn-grund-und-boden.pre-init');
    if (vn_widgets) {
      vn_widgets.forEach(widget => {
        init_slider(widget);
      });
    }
  };

  $(document).ready(function () {
    init();
    window.addEventListener('newPage', init, false);
  });
})(window, document);
